<ng-container *ngIf="status$ | async as calcStatus">
    <a
        *ngIf="state !== 'loading'"
        (click)="runCalc()"
        class="d-inline-flex link align-items-center cursor-pointer"
    >
        Run calculations
        <i-tabler name="player-play" class="sb-icon-lg ms-1"></i-tabler>
    </a>

    <a *ngIf="state === 'loading'" class="d-inline-flex link align-items-center">
        Calculation in progress
        <sb-pending-button-indicator [state]="state"></sb-pending-button-indicator>
    </a>
</ng-container>
